import React from 'react';
import { SectionProps } from './section.types';

import classes from './section.module.css';

const Section: React.FC<SectionProps> = ({ title, children }) => {
    return (
        <div className={classes['context-panel-section']}>
            {title &&<h3 className={classes['section-title']}>{title}</h3>}
            <div className={classes['section-content']}>
                {children}
            </div>
        </div>
    );
};

export { Section };
